export function validateMobileNumber(mobile){
  const phoneNumberRegex = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/
  return phoneNumberRegex.test(mobile);
}

export function validateEmail(value){
  return String(value)
  .toLowerCase()
  .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
}

export function validURL (url) {
  const regex = /^(https?:\/\/)?((www\.)?[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}(:\d{1,5})?(\/[^\s]*)?$/;
  return regex.test(url);
}